export default "__VITE_ASSET__RCRDee8Q__"